import { X, Check, ArrowRight } from "lucide-react";

const replaced = [
  "Carnet HACCP papier",
  "Tableur de planning",
  "Appli de pointage à part",
  "Fichier Excel de stock",
  "Carnet de commandes fournisseurs",
  "Classeur de factures papier",
  "Calculette de caisse",
];

export default function AllInOne() {
  return (
    <section className="border-y border-ink/[0.06] bg-paper py-14 sm:py-16">
      <div className="mx-auto max-w-content px-5 sm:px-8">
        <p className="text-center text-sm font-medium uppercase tracking-wide text-ink-soft">
          Ce qu'Hygio remplace
        </p>

        <div className="mt-6 flex flex-col items-center gap-4 lg:flex-row lg:justify-center lg:gap-5">
          <div className="flex flex-wrap justify-center gap-2.5">
            {replaced.map((item) => (
              <span
                key={item}
                className="inline-flex items-center gap-1.5 rounded-full border border-ink/10 bg-mist px-3.5 py-2 text-sm text-ink-soft"
              >
                <X size={14} className="text-ink-soft/50" strokeWidth={2.5} />
                {item}
              </span>
            ))}
          </div>

          <ArrowRight
            size={20}
            className="hidden shrink-0 text-ink-soft/40 lg:block"
          />

          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent px-4 py-2 text-sm font-medium text-white">
            <Check size={15} strokeWidth={2.5} />
            Une seule appli : Hygio
          </span>
        </div>
      </div>
    </section>
  );
}
